import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ChatBubble } from '@/components/chat/ChatBubble';

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="h-screen flex flex-col">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

      <div className="flex-1 flex overflow-hidden">
        <Sidebar isOpen={sidebarOpen} />

        <main className="flex-1 overflow-auto bg-main-content-bg">
          <div className="max-w-[1600px] mx-auto p-10">
            <Outlet />
          </div>
        </main>
      </div>

      {/* AI Chat Bubble */}
      <ChatBubble />
    </div>
  );
}
